import React, { useEffect, useState } from 'react';
import useAxiosPrivateSAI from '../../../../hooks/useAxiosPrivateSAI';

const StepThree = ({ data, onUpdate }) => {
  const [accepted, setAccepted] = useState(data?.accepted || false)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [status, setStatus] = useState(null)
  const axios = useAxiosPrivateSAI()

  useEffect(() => {
    onUpdate && onUpdate({ accepted });
    console.log(accepted)
  }, [accepted]);

  const submitClaim = async () => {
    setSubmitting(true);

    try {
      const claimId = localStorage.getItem('claim_id');
      const response = await axios.get(`/api/claims/calculate/${claimId}`);

      setSubmitted(true);
      setStatus(response.data.status.id);
    } catch (error) {
      console.error('Failed to submit claim:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="border border-gray-300 rounded-md p-4 text-sm text-gray-700">
        <h3 className="font-semibold mb-2">Declaration Statement</h3>
        <p>
          I/We declare to the best of my/our knowledge or belief, the statements given in this document are true and complete. I/We agree by joining Schools Mutual as a member we will abide by the rules of the mutual as set out in this important information and Membership Pack.
          We may be able to process payment requests, provided they are reported within the scheme period defined on your Schools Mutual Statement. Documentation must be provided if requested by Schools Mutual, including but not limited to self-certification, medical certificate/fit to work note, medical consent forms and absence history. In the event of an ongoing absence, it is the responsibility of the school to provide Schools Mutual with the requested information within the scheme year.
          Information provided to Schools Mutual in connection with this scheme will be used for the purpose of providing reimbursements payments for absences and assistance services. The information will be handled in accordance with applicable data protection laws and conformance with appropriate compliance and regulatory guidelines. Personal details are kept confidential through the use of Secure Sockets Layer (SSL). This means that information is covered by 256-bit encryption for the padlock symbol in the status bar at the bottom of your browser window. The scheme may disclose information it holds on the scheme member, the staff members and other parties to a Government authority or regulatory body in connection with the prevention and investigation of crime, including fraud and money laundering. The school, a person acting on behalf of the school, or staff members must not act in a fraudulent way.
        </p>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">I have read and accept the declaration</label>
        <div
          className={`relative inline-flex w-11 shrink-0 rounded-full p-0.5 transition-colors duration-200 ease-in-out ${
            accepted ? 'bg-indigo-600' : 'bg-gray-200'
          }`}
        >
          <input
            id="phased-return-toggle"
            name="phased-return"
            type="checkbox"
            className="peer absolute inset-0 z-10 opacity-0 cursor-pointer"
            checked={accepted}
            onChange={() => setAccepted(!accepted)}
            aria-label="Use setting"
          />
          <span className="relative size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out peer-checked:translate-x-5">
            {accepted ? (
              <span className="absolute inset-0 flex items-center justify-center">
                <svg fill="currentColor" viewBox="0 0 12 12" className="size-3 text-indigo-600">
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              </span>
            ) : (
              <span className="absolute inset-0 flex items-center justify-center">
                <svg fill="none" viewBox="0 0 12 12" className="size-3 text-gray-400">
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
        </div>
      </div>
      
      {/* {accepted && (
        <div>
          <button className="px-4 py-2 text-sm font-medium text-white bg-sas rounded-md hover:bg-sas-dark" onClick={submitClaim}>Confirm</button>
        </div>
      )} */}
      
    </div>
  );
};

export default StepThree;
